
namespace TabAurous.ProductDevelopment {

    @Serenity.Decorators.registerClass()
    export class QuotationLaborGrid extends Serenity.EntityGrid<PDQuotationLaborRow, any> {
        protected getColumnsKey() { return 'Common.CommonLabour'; }
        protected getIdProperty() { return PDQuotationLaborRow.idProperty; }
        protected getInsertPermission() { return PDQuotationLaborRow.insertPermission; }
        protected getLocalTextPrefix() { return PDQuotationLaborRow.localTextPrefix; }
        protected getService() { return PDQuotationLaborService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });
        }
    }
}